import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const APIKeyCreatedDialog = ({ open, secretData, onClose, onCopy }) => {
  if (!secretData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Save your API key</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This secret is shown only once. Copy it now and store it securely.
        </Alert>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Label: <strong>{secretData.label}</strong>
        </Typography>
        {secretData.expiresAt ? (
          <Typography variant="body2" sx={{ mb: 2 }}>
            Expires: {new Date(secretData.expiresAt).toLocaleString()}
          </Typography>
        ) : (
          <Typography variant="body2" sx={{ mb: 2 }}>
            Expiration: <strong>Never</strong>
          </Typography>
        )}
        <TextField
          fullWidth
          multiline
          minRows={3}
          value={secretData.secret}
          InputProps={{ readOnly: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCopy(secretData.secret)} startIcon={<ContentCopyIcon />}>
          Copy secret
        </Button>
        <Button variant="contained" onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default APIKeyCreatedDialog;
